import React from 'react';
import moment from 'moment';
import Form from 'antd/lib/form';
import Select from 'antd/lib/select';
import 'antd/lib/select/style/index.css';
var Option = Select.Option;
var InputUtcOffset = function (props) { return (React.createElement(Form.Item, { label: 'Timezone for event', extra: 'Please account for daylight-savings. We use this to create a localized event schedule for an international audience.', colon: false }, props.form.getFieldDecorator('utcOffset', {
    initialValue: props.initialValue || moment().utcOffset().toString(),
    rules: [{
            required: true,
            message: 'We need your timezone to show the event schedule accurately',
        }],
})(React.createElement(Select, { size: 'large', disabled: props.isDisabled },
    React.createElement(Option, { value: '-720' }, "(GMT -12:00) Eniwetok, Kwajalein"),
    React.createElement(Option, { value: '-660' }, "(GMT -11:00) Midway Island, Samoa"),
    React.createElement(Option, { value: '-600' }, "(GMT -10:00) Hawaii"),
    React.createElement(Option, { value: '-540' }, "(GMT -9:00) Alaska"),
    React.createElement(Option, { value: '-480' }, "(GMT -8:00) Pacific Time (US & Canada)"),
    React.createElement(Option, { value: '-420' }, "(GMT -7:00) Mountain Time (US & Canada)"),
    React.createElement(Option, { value: '-360' }, "(GMT -6:00) Central Time (US & Canada), Mexico City"),
    React.createElement(Option, { value: '-300' }, "(GMT -5:00) Eastern Time (US & Canada), Bogota, Lima"),
    React.createElement(Option, { value: '-240' }, "(GMT -4:00) Atlantic Time (Canada), Caracas, La Paz"),
    React.createElement(Option, { value: '-210' }, "(GMT -3:30) Newfoundland"),
    React.createElement(Option, { value: '-180' }, "(GMT -3:00) Brazil, Buenos Aires, Georgetown"),
    React.createElement(Option, { value: '-120' }, "(GMT -2:00) Mid-Atlantic"),
    React.createElement(Option, { value: '-60' }, "(GMT -1:00) Azores, Cape Verde Islands"),
    React.createElement(Option, { value: '0' }, "(GMT) Western Europe Time, London, Lisbon, Casablanca"),
    React.createElement(Option, { value: '60' }, "(GMT +1:00) Brussels, Copenhagen, Madrid, Paris"),
    React.createElement(Option, { value: '120' }, "(GMT +2:00) Kaliningrad, South Africa"),
    React.createElement(Option, { value: '180' }, "(GMT +3:00) Baghdad, Riyadh, Moscow, St. Petersburg"),
    React.createElement(Option, { value: '210' }, "(GMT +3:30) Tehran"),
    React.createElement(Option, { value: '240' }, "(GMT +4:00) Abu Dhabi, Muscat, Baku, Tbilisi"),
    React.createElement(Option, { value: '270' }, "(GMT +4:30) Kabul"),
    React.createElement(Option, { value: '300' }, "(GMT +5:00) Ekaterinburg, Islamabad, Karachi, Tashkent"),
    React.createElement(Option, { value: '330' }, "(GMT +5:30) Bombay, Calcutta, Madras, New Delhi"),
    React.createElement(Option, { value: '465' }, "(GMT +5:45) Kathmandu"),
    React.createElement(Option, { value: '360' }, "(GMT +6:00) Almaty, Dhaka, Colombo"),
    React.createElement(Option, { value: '420' }, "(GMT +7:00) Bangkok, Hanoi, Jakarta"),
    React.createElement(Option, { value: '480' }, "(GMT +8:00) Beijing, Perth, Singapore, Hong Kong"),
    React.createElement(Option, { value: '540' }, "(GMT +9:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk"),
    React.createElement(Option, { value: '570' }, "(GMT +9:30) Adelaide, Darwin"),
    React.createElement(Option, { value: '600' }, "(GMT +10:00) Eastern Australia, Guam, Vladivostok"),
    React.createElement(Option, { value: '660' }, "(GMT +11:00) Magadan, Solomon Islands, New Caledonia"),
    React.createElement(Option, { value: '720' }, "(GMT +12:00) Auckland, Wellington, Fiji, Kamchatka"))))); };
export default InputUtcOffset;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormEventPage/FormEvent/InputUtcOffset.tsx
// module id = 1108
// module chunks = 0